export const typeOfSaveFormModal = 'typeOfSaveFormModal';
export const saveFormModalReducerKey = 'saveFormModalReducerKey';
export const RESET_STATE = 'RESET_STATE';
export const UPDATE_SETTINGS_PARAMS = 'UPDATE_SETTINGS_PARAMS';
export const UPDATE_STATE_PARAMS = 'UPDATE_STATE_PARAMS';
export const INITIALIZE_DATA = 'INITIALIZE_DATA';
